import Component from '../core/Component'
import Scroll, { scrollToElement } from '../services/Scroll'

const STATES = {
    BREAKPOINT: 'is-breakpoint'
}

export default class Page extends Component {

    constructor(element, options) {
        super(element, options)

        this.state = {
            isBreakpoint: false
        }
    }

    prepare() {
        this.element.addEventListener('click', this.handleClick)
        // Scroll.on('scroll', this.handleScroll)
    }

    destroy() {
        // Scroll.off('scroll', this.handleScroll)
    }

    handleClick = event => {
        if (event.defaultPrevented) {
            return
        }

        const target = event.target.closest('a')
        if (!target) {
            return
        }

        if (document.location.href.split('#')[0] !== target.href.split('#')[0]) {
            return
        }

        const id = target.href.split('#')[1]
        if (!id) {
            return
        }

        const element = document.getElementById(id)
        if (!element) {
            return
        }

        event.preventDefault()

        let offset = (target.dataset.offset) ? target.dataset.offset : 0
        let mode = (target.dataset.mode) ? target.dataset.mode : 'force-center'

        scrollToElement(element, { offset, mode })
    }

    // handleScroll = scrollEvent => {
    //     if (scrollEvent.y > 150) {
    //         if (!this.isBreakpoint) {
    //             this.element.classList.add(STATES.BREAKPOINT)
    //             this.isBreakpoint = true
    //         }
    //     } else {
    //         if (this.isBreakpoint) {
    //             this.element.classList.remove(STATES.BREAKPOINT)
    //             this.isBreakpoint = false
    //         }
    //     }
    // }


}